export const EMAILJS_SERVICE_ID = "service_g8aw7qb";
export const EMAILJS_CONTACT_TEMPLATE_ID = "template_bpn0uzc";
export const EMAILJS_AUTOREPLY_TEMPLATE_ID = "template_ynyqjt9";
export const EMAILJS_PUBLIC_KEY = "shpjT4RgCRAb4cgTV";
